var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWildgrainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 368.24 48.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #FF6247;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.66.89l-11,46.49h-15.13l-4.19-19.19-4.19,19.19h-15.13L0,.89h14.51l4.68,21.8L24.55.89h11.55l5.36,21.8L46.15.89h14.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.08.96h13.75v46.35h-13.75V.96Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.04,34.52v12.86h-29.09V.89h13.75v33.63h15.34Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.37.96h14.92c14.1,0,24.14,9.63,24.14,23.18s-9.97,23.18-24.07,23.18h-14.99V.96ZM138.22,35.21c6.05,0,10.18-4.54,10.18-11.07s-4.13-11.07-10.18-11.07h-1.1v22.14h1.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.93,24.14c0-13.75,10.11-24.14,23.59-24.14,5.16,0,9.35,1.38,13.27,4.33l-5.29,11.55c-2.27-1.51-4.75-2.27-7.29-2.27-5.85,0-10.25,4.54-10.25,10.52,0,6.67,4.4,11.76,10.25,11.76,1.17,0,2.54-.27,4.2-.76v-4.4h-6.46v-11.14h19.26v22.76c-4.61,3.78-10.87,5.91-17.47,5.91-13.69,0-23.79-10.32-23.79-24.14Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.92,47.32h-16.02l-6.88-11.83h-.69v11.83h-13.75V.96h16.16c10.59,0,18.09,6.81,18.09,16.3,0,5.71-2.61,10.66-7.15,13.48l10.25,16.57ZM237.79,18.43c0-2.54-1.99-4.4-4.75-4.4h-1.72v8.73h1.72c2.75,0,4.75-1.79,4.75-4.33Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.9.89h17.26l13.96,46.49h-14.1l-1.65-5.98h-13.69l-1.65,5.98h-14.1L271.9.89ZM284.21,29.3l-3.64-14.3-3.65,14.3h7.29Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.76.96h13.75v46.35h-13.75V.96Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.24.89v46.49h-11.76l-12.1-20.84v20.84h-13.75V.89h12.17l11.69,18.64V.89h13.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWildgrainLogo);
export default __webpack_public_path__ + "static/media/wildgrain_logo.2deeb460aa7a12b673d573679ba72aa9.svg";
export { ForwardRef as ReactComponent };